import ApplicationController from '@aha-app/mvc';
import { User } from 'components/framework/models';
import { type RecordId } from 'javascripts/shared-types';

interface UserValue {
  label: string;
  value: string;
  avatar: string;
  initials: string;
}

export interface UserSelectorProps {
  className?: string;
  editable?: boolean;
  value: UserValue[];
  selectroProps: any;
  onSelect: (value: string, selected: boolean) => void;
  onClear?: () => void;
}

interface State {
  users: User[];
}

export class UserSelectorController extends ApplicationController<
  State,
  UserSelectorProps
> {
  async initialize(props: UserSelectorProps) {
    this.mapUsersToState(props.value);
  }

  changeProps(newProps: UserSelectorProps, oldProps: UserSelectorProps): void {
    if (
      newProps.value.map(user => user.value).join() !==
      oldProps.value.map(user => user.value).join()
    ) {
      this.mapUsersToState(newProps.value);
    }
  }

  mapUsersToState(users: UserValue[]) {
    this.state.users = users.map(user => {
      return new User({
        initials: user.initials,
        name: user.label,
        avatarUrl: user.avatar,
        id: user.value,
      });
    });
  }

  get selectroTriggerUsers() {
    // I don't really like that we have a controller for the user selector, it's doing a lof of things selectro does already,
    // because of that we have to return the users in a format that selectro expects, and check for any duplicates.
    return this.state.users.reduce((acc, user) => {
      if (!acc.some(item => item.value === user.id)) {
        acc.push({
          value: user.id,
          text: user.name,
          label: user.name,
          avatar: user.avatarUrl || '',
          initials: user.initials,
        });
      }
      return acc;
    }, [] as Array<{ value: string; text: string; label: string; avatar: string; initials: string }>);
  }

  async actionToggleUser(userId: RecordId, selected: boolean) {
    this.props.onSelect(userId, selected);

    if (!selected) {
      this.state.users = this.state.users.filter(user => user.id !== userId);
    } else {
      const user = await User.select(
        'id',
        'name',
        'initials',
        'avatarUrl'
      ).find(userId);
      this.state.users.push(user);
    }
  }

  async actionClearUsers() {
    if (this.props.onClear) this.props.onClear();
    this.state.users = [];
  }
}
